var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBCartPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-cart-plus",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-cart-plus1",
    serifid: "iconB-cart-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.895,4.535l-0,-1.507c-0,-0.542 0.44,-0.982 0.982,-0.982c0.542,0 0.982,0.44 0.982,0.982c-0,0 -0,1.507 -0,1.507l1.498,0c0.542,0 0.982,0.44 0.982,0.982c-0,0.542 -0.44,0.982 -0.982,0.982c-0,0 -1.498,0 -1.498,0l-0,1.507c-0,0.542 -0.44,0.982 -0.982,0.982c-0.542,0 -0.982,-0.44 -0.982,-0.982c-0,0 -0,-1.507 -0,-1.507l-1.498,0c-0.542,0 -0.982,-0.44 -0.982,-0.982c-0,-0.542 0.44,-0.982 0.982,-0.982l1.498,0Zm-2.402,10.424l10.557,-2.533l0,-5.925l-1.293,-0.002c-0.542,-0 -0.981,-0.44 -0.981,-0.981c-0,-0.542 0.439,-0.982 0.981,-0.982l2.05,0c0.653,-0 1.246,0.62 1.246,1.238c-0,0.011 -0.004,5.503 -0.004,7.131c0,1.045 -0.869,1.287 -1.118,1.352c-0.002,0.001 -0.004,0.001 -0.006,0.002c0,-0 -10.854,2.687 -11.731,2.887c-0.222,0.051 -0.383,0.015 -0.427,0.008c-0.512,-0.08 -0.701,-0.522 -0.729,-0.583c-0.161,-0.355 -4.771,-10.06 -5.337,-11.598c-0.473,-0.003 -1.731,-0.011 -1.734,-0.011c-1.3,0 -1.27,-1.967 0,-1.967c0.482,-0 2.639,0.012 2.639,0.012c0,-0 0.688,-0.005 0.933,0.666c0.205,0.558 0.263,0.715 0.319,0.863c0.14,0 0.965,0 2.173,0c0.543,0 0.984,0.442 0.984,0.985c-0,0.543 -0.441,0.985 -0.984,0.985c0,-0 -1.461,0.001 -1.461,0.001c0.513,1.379 3.283,7.127 3.836,8.271c0.043,0.09 0.073,0.152 0.087,0.181Zm-4.493,2.04c1.104,0 2,0.897 2,2c-0,1.104 -0.896,2 -2,2c-1.104,0 -2,-0.896 -2,-2c-0,-1.103 0.896,-2 2,-2Zm11.742,0c1.104,0 2,0.897 2,2c0,1.104 -0.896,2 -2,2c-1.104,0 -2,-0.896 -2,-2c0,-1.103 0.896,-2 2,-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBCartPlus);
export default __webpack_public_path__ + "static/media/iconB-cart-plus.8c6d527cf731f3290546ca6b1779403d.svg";
export { ForwardRef as ReactComponent };